<!-- @Author: Yu_Bo -->
<template>
    <div class=''>
        <div class="table_wrap height">
            <el-table ref="table1" key="table1" :data="list" v-loading="loading" @sort-change="onSortChange" @selection-change="handleSelectionChange"
                style="width: 100%" header-cell-class-name="table-header" cell-class-name="cell-class">
                <template slot="empty">
                    <empty-data img='no_img_b.png' text='暂无数据'></empty-data>
                </template>
                <el-table-column type="selection" width="55" fixed="left">
                </el-table-column>
                <el-table-column prop="id" label="用户ID" fixed="left">
                </el-table-column>
                <el-table-column prop="mobile" label="登录手机账号" width="125" fixed="left">
                </el-table-column>
                <el-table-column prop="" label="代理名称" width="145" fixed="left">
                    <template slot-scope="scope">
                        <div class="flex_box">
                            <div v-if="scope.row.corp_id == 0" class="isPerson">个人</div>
                            <div v-if="scope.row.corp_id > 0" class="isCompony">企业</div>
                            <div class="txt_wrap">{{ scope.row.nickname }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="source_name" label="注册来源" width="125">
                </el-table-column>
                <el-table-column prop="" label="订阅套餐类型" width="125">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="subscribeDetailBtn(scope.row)">
                            {{ scope.row.subscribe_name }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="订阅有效期" width="125">
                    <template slot-scope="scope">
                        <div v-if="scope.row.subscribe_started && scope.row.subscribe_ended">{{ scope.row.subscribe_started
                        }}/{{ scope.row.subscribe_ended }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="代理有效期" width="125">
                    <template slot-scope="scope">
                        <div v-if="scope.row.agency_started && scope.row.agency_ended">{{ scope.row.agency_started }}/{{
                            scope.row.agency_ended }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="diamond" label="钻石余额" width="125">
                </el-table-column>
                <el-table-column prop="diamond_con" label="钻石总消耗" width="125">
                </el-table-column>
                <el-table-column prop="video_duration_text" label="时长余额" width="125">
                </el-table-column>
                <el-table-column prop="major_cust" label="剩余次数" width="125">
                </el-table-column>
                <el-table-column prop="buy_mo" label="购买模型个数" width="125">
                </el-table-column>
                <el-table-column prop="customize_mo" label="定制模型个数" width="125">
                </el-table-column>
                <el-table-column prop="total_works_num" label="作品总数" width="125">
                </el-table-column>
                <el-table-column prop="avg_works_time" label="平均作品时长" width="125">
                </el-table-column>
                <el-table-column prop="create_time" label="账户注册时间" width="135" sortable="custom">
                </el-table-column>
                <el-table-column prop="tj_time" label="提交代理时间" width="135" sortable="custom">
                </el-table-column>
                <el-table-column prop="audit_time" label="审核代理时间" width="135" sortable="custom">
                </el-table-column>
                <el-table-column prop="" label="是否启用" width="125">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="2"
                            @change="statusEdit(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="recharge(scope.row.id)">
                            充值
                        </el-button>
                        <el-button type="text" size="small" @click="proxyEdit(scope.row.id)">
                            编辑
                        </el-button>
                        <el-button type="text" size="small" @click="toDetail(scope.row.id)">
                            详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 订阅详情 -->
        <subscribe-detail ref="SubscribeDetails"></subscribe-detail>
        <!-- 充值 -->
        <recharge-popup :topup="topup" @getList="getList" ref="recharge"></recharge-popup>
    </div>
</template>

<script>
import EmptyData from '@/components/empty_data/empty_data.vue'//空数据
import SubscribeDetail from '../subscribeDetail/subscribeDetail.vue' // 订阅详情
import RechargePopup from '../rechargePopup/index.vue' //充值

export default {
    components: {
        EmptyData,
        SubscribeDetail,
        RechargePopup,
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        topup: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {
        // 充值
        recharge(id) {
            this.$refs.recharge.open(id, 'proxy')
        },
        // 订阅详情
        subscribeDetailBtn(info) {
            this.$refs.SubscribeDetails.openDialogBtn(info)
        },
        // 代理编辑
        proxyEdit(id) {
            this.$emit('proxyEdit', id)
        },
        // 状态修改
        statusEdit(info) {
            this.$emit('statusEdit', info)
        },
        //  修改列表
        getList() {
            this.$emit('getList', '')
        },
        // 列表排序
        onSortChange(column) {
            this.$emit('onSortChange', column)
        },
        // 列表筛选
        handleSelectionChange(val) {
            this.$emit('handleSelectionChange', val)
        },
        // 跳转详情页
        toDetail(id) {
            this.$router.push({
                path: '/proxy/detail',
                query: {
                    id: id
                }
            })
        }
    },
}
</script>

<style lang='scss' scoped>@import "./index.scss";</style>